export class BannerModel {

  public id: number;
  public name: string;
  public assessment_id: number;
  public trilha_id: number;
  public value: BannerValue;
  public page: string;
  public type: string;

  constructor(
    id: number,
    name: string,
    value: any,
    assessment_id: number,
    trilha_id: number,
    page: string,
    type: string
  ) {
    this.id = id;
    this.name = name;
    this.value = value;
    this.assessment_id = assessment_id;
    this.trilha_id = trilha_id;
    this.page = page;
    this.type = type;
  }


}

export class BannerValue {

  public title: {text: string, align: string, size: number, color: string};
  public subtitle: {text: string, align: string, size: number, color: string};
  public description: {text: string, align: string, size: number, color: string};
  public button: {text: string, color: string, background: string};
  public text_color: string;
  public size: string;
  public background: {type: string, colorPrimary: string, colorSecondary: string, image: string};
  public target: string;

  constructor() {
    this.title = {text: 'Título aqui', align: 'center', size: 32, color: '#333333'};
    this.subtitle = {text: 'Sub-título aqui', align: 'center', size: 24, color: '#333333'};
    this.description = {text: 'Texto aqui', align: 'center', size: 16, color: '#333333'};
    this.button = {text: 'Botão', color: '#FFFFFF', background: '#333333'};
    this.size = 'medium';
    this.background = {type: 'color', colorPrimary: '#ffffff', colorSecondary: '#ffffff', image: ''};
    this.target = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/@core/models/banner.model.ts